import React, { Component } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Label, InputGroup, Input, ButtonGroup, Button, ListGroup, ListGroupItem, CardFooter } from 'reactstrap';
import LaddaButton, { EXPAND_LEFT } from 'react-ladda';
import { toast } from 'react-toastify';
import async from 'async';

import Config from '../../config';
import Lang from '../../languages';



class SettingsEditor extends Component {
 constructor(props) {
  super(props);

  this.roles = {
   users: {
    operators: ["read", "create", "update", "delete"],
    providers: ["read", "create", "update", "delete"],
    administrators: ["read", "create", "update", "delete"]
   },
   controllers: {
    tickets: ["read", "create", "update", "delete"],
    products: ["read", "create", "update", "delete"],
    establishments: ["read", "create", "update", "delete"]
   }
  }

  this.state = {
   userRoles: {},
   rolesEditable: false,
   selectedRole: 'administrators',
   initialTypes: {},
   productTypes: {}
  }

  this.handleTypeLanguage = this.handleTypeLanguage.bind(this);
  this.handleTypeInput = this.handleTypeInput.bind(this);
  this.handleTypeState = this.handleTypeState.bind(this);
  this.handleTypeSave = this.handleTypeSave.bind(this);

  this.typeSave = this.typeSave.bind(this);
  this.typeSaveAll = this.typeSaveAll.bind(this);
  this.typeDelete = this.typeDelete.bind(this);

  this.checkBoxValue = this.checkBoxValue.bind(this);
  this.checkBoxStatus = this.checkBoxStatus.bind(this);
 }

 componentDidMount() {
  var self = this;
  var request = {};

  request.roles = function (callback) {
   self.props.reqAPI(Config.apiURI + '/api/users/roles').then(results => {
    if (results.success) {
     callback(false, results.roles);
    } else {
     callback(true);
    }
   })
  }

  request.types = function (callback) {
   self.props.reqAPI(Config.apiURI + '/api/products/types').then(results => {
    if (results.success) {
     callback(false, results.items);
    } else {
     callback(true);
    }
   })
  }

  async.parallel(request, function (err, results) {
   if (!err) {
    var userRoles = {};
    var selectedRole = self.state.selectedRole;
    results.roles.sort().map(rol => {
     if (!selectedRole) selectedRole = rol.name;
     userRoles[rol.name] = JSON.parse(rol.permissions)
    })

    var initialTypes = {};
    var productTypes = {};
    results.types.map(item => {
     if (!initialTypes[item.ID]) initialTypes[item.ID] = {};
     if (!productTypes[item.ID]) productTypes[item.ID] = {};
     initialTypes[item.ID][item.language] = item.name;
     productTypes[item.ID][item.language] = item.name;
     initialTypes[item.ID].selected = self.props.session.language;
     initialTypes[item.ID].failed = [];
     initialTypes[item.ID].uses = parseInt(item.uses);
    })

    self.setState({ userRoles, selectedRole, initialTypes, productTypes });
   }
  })
 }

 handleTypeLanguage(e) {
  var typeID = e.target.id;
  var typeLang = e.target.value;
  this.setState(prevState => ({
   initialTypes: {
    ...prevState.initialTypes,
    [typeID]: {
     ...prevState.initialTypes[typeID],
     selected: typeLang
    },
   },
  }))
 }

 handleTypeInput(e) {
  var typeID = e.target.id;
  var typeVal = e.target.value;
  this.setState(prevState => ({
   productTypes: {
    ...prevState.productTypes,
    [typeID]: {
     ...prevState.productTypes[typeID],
     [prevState.initialTypes[typeID].selected]: typeVal
    },
   },
  }))
 }

 handleTypeState(ID) {
  var changed = false;
  Object.keys(this.state.productTypes[ID]).map(language => {
   if (this.state.initialTypes[ID] && this.state.initialTypes[ID][language] != this.state.productTypes[ID][language]) changed = true;
  })
  return changed;
 }



 typeSave(ID) {
  var initialTypes = this.state.initialTypes;
  Object.keys(initialTypes).map(ID => { initialTypes[ID].failed = [] });
  this.setState({ initialTypes })
  this.props.reqAPI(Config.apiURI + '/api/products/types/' + ID, 'PUT', this.state.productTypes[ID]).then((results) => {
   var initialTypes = this.handleTypeSave(ID, results);
   this.setState({ initialTypes });
  })
 }

 typeSaveAll() {
  var self = this, jobs = {};
  Object.keys(this.state.productTypes).map(ID => {
   jobs[ID] = function (callback) {
    var initialTypes = self.state.initialTypes;
    Object.keys(initialTypes).map(ID => { initialTypes[ID].failed = [] });
    self.setState({ initialTypes }, () => {
     self.props.reqAPI(Config.apiURI + '/api/products/types/' + ID, 'PUT', self.state.productTypes[ID]).then((result) => { callback(false, result) });
    })
   }
  })

  async.parallel(jobs, function (err, results) {
   var initialTypes = self.state.initialTypes;
   Object.keys(results).map(ID => {
    initialTypes = self.handleTypeSave(ID, results[ID]);
   })
   self.setState({ initialTypes });
  })
 }

 typeDelete(ID) {
  this.props.reqAPI(Config.apiURI + '/api/products/types/' + ID, 'DELETE').then((result) => {
   if (result.success) {
    var typeID = result.ID;
    var initialTypes = this.state.initialTypes;
    var productTypes = this.state.productTypes;
    delete initialTypes[typeID];
    delete productTypes[typeID];
    this.setState({ initialTypes, productTypes });
   } else {
    toast.error(Lang[this.props.session.language].Products.typeHasNotBeenDeleted(this.state.productTypes[ID][this.props.session.language]));
   }
  }).catch((error) => {
   console.error(error);
  })
 }

 handleTypeSave(ID, results) {
  var initialTypes = this.state.initialTypes;
  var productTypes = this.state.productTypes;

  if (results.success) {
   var failed = [];
   var selected = initialTypes[ID].selected;
   var duplicated = false;
   initialTypes[ID] = { ...productTypes[ID], selected, failed, uses: initialTypes[ID].uses };
  } else {
   var failed = results.failed;
   var selected = results.failed[0];
   var duplicated = results.message.match(/Duplicated:(.*)/);
   initialTypes[ID] = { ...initialTypes[ID], selected, failed };
  }

  Object.keys(productTypes[ID]).map(language => {
   if (productTypes[ID][language] == '') initialTypes[ID][language] = null;
  })

  if (duplicated) {
   var duplicatedID = duplicated[1];
   initialTypes[duplicatedID] = { ...initialTypes[duplicatedID], selected, failed };
  }

  return initialTypes;
 }

 checkBoxValue(group, element, perm, event) {
  var userRoles = this.state.userRoles;
  if (this.state.selectedRole != '') {
   if (userRoles[this.state.selectedRole]) {
    if (userRoles[this.state.selectedRole][group]) {
     if (userRoles[this.state.selectedRole][group][element]) {
      var el = userRoles[this.state.selectedRole][group][element].find(el => el == perm);
      if (el === undefined) {
       userRoles[this.state.selectedRole][group][element].push(perm);
      } else {
       this.state.userRoles[this.state.selectedRole][group][element] = this.state.userRoles[this.state.selectedRole][group][element].filter(function (el) { return el != perm; });
      }
     }
    }
   }
  }

  this.setState({ userRoles });
 }

 checkBoxStatus(group, element, perm) {
  if (this.state.selectedRole != '') {
   if (this.state.userRoles[this.state.selectedRole]) {
    if (this.state.userRoles[this.state.selectedRole][group]) {
     if (this.state.userRoles[this.state.selectedRole][group][element]) {
      return this.state.userRoles[this.state.selectedRole][group][element].find(el => el == perm)
     }
    }
   }
  }

  return false;
 }

 render() {

  const capitalize = (s) => {
   if (typeof s !== 'string') return ''
   return s.charAt(0).toUpperCase() + s.slice(1)
  }
  return (
   <Row>
    <Col xs="5">
     <Card>
      <CardHeader>
       <strong>{Lang[this.props.session.language].Settings.types}</strong>
       <span role="button" className="float-right text-primary" onClick={this.typeSaveAll}>{Lang[this.props.session.language].Products.buttons.saveAll}</span>

      </CardHeader>
      <CardBody>
       {
        Object.keys(this.state.productTypes).map((item, key) => {
         return (
          <InputGroup key={key} className="mb-1">
           <Input id={item} type="select" style={{ width: '30%' }} onChange={this.handleTypeLanguage} value={this.state.initialTypes[item].selected}>
            {
             Object.keys(Lang[this.props.session.language].languages).map((key, index) => {
              return (<option key={index} value={key}>{Lang[this.props.session.language].languages[key]}</option>)
             })
            }
           </Input>
           <Input id={item} type="text" style={{ width: '55%' }}
            onKeyUp={(e) => { if (e.key === 'Enter' || e.keyCode === 13) this.typeSave(item) }}
            onChange={this.handleTypeInput} value={this.state.productTypes[item][this.state.initialTypes[item].selected]}
            className={this.state.initialTypes[item].failed.includes(this.state.initialTypes[item].selected) ? 'border-danger' : ''}
           />
           <ButtonGroup style={{ width: '15%' }}>
            <Button className="ml-1" color="success" outline={!this.handleTypeState(item)} disabled={!this.handleTypeState(item)} onClick={() => this.typeSave(item)}><i className="fa fa-solid fa-check"></i></Button>
            <Button className="ml-1" color="danger" outline disabled={this.state.initialTypes[item].uses > 0} onClick={() => this.typeDelete(item)}><i className="fa fa-solid fa-trash"></i></Button>
           </ButtonGroup>
          </InputGroup>
         )
        })
       }
       <Button className="container" color="primary" outline onClick={() => {
        var IDs = Object.keys(this.state.productTypes).map(key => parseInt(key));
        var newID = Math.max(...IDs) + Math.floor(Math.random() * 15);
        // ADD type
        var initialType = Object.keys(Lang[this.props.session.language].languages).map((lang, key) => ({ [lang]: null }));
        var productType = Object.keys(Lang[this.props.session.language].languages).map((lang, key) => ({ [lang]: '' }));
        var initialType = initialType.reduce((obj, item) => Object.assign(obj, item), {});
        var productType = productType.reduce((obj, item) => Object.assign(obj, item), {});
        this.setState(prevState => ({
         initialTypes: {
          ...prevState.initialTypes,
          [newID]: { ...initialType, selected: this.props.session.language, failed: [], uses: 0 },
         },
         productTypes: {
          ...prevState.productTypes,
          [newID]: { ...productType },
         }
        }))
       }}>{Lang[this.props.session.language].Products.buttons.addType}</Button>

      </CardBody>
     </Card>
    </Col>
    <Col xs="7">
     <Card>
      <CardHeader>
       <strong>{Lang[this.props.session.language].Settings.roles}</strong>
       {
        this.state.rolesEditable
         ? <span role="button" className="float-right text-primary" onClick={() => {
         }}>{Lang[this.props.session.language].Products.buttons.saveChanges}</span>
         : null
       }
      </CardHeader>
      <CardBody>
       <Row>
        <Col xs="3">
         <ListGroup>
          {
           Object.keys(this.roles.users).sort().map((role, key) => {
            return (
             <ListGroupItem key={key} onClick={() => this.setState({ selectedRole: role })}>
              <span role="button" className={this.state.selectedRole === role ? 'text-primary' : ''}>{Lang[this.props.session.language].Users.titles[role]}</span>
             </ListGroupItem>
            )
           })
          }
         </ListGroup>
        </Col>
        <Col xs="9">
         <Row>
          <Col xs="6">
           {
            Object.keys(this.roles.users).map((role, key) => {
             return (
              <div key={key} className="mb-3">
               <h4>{Lang[this.props.session.language].Users.titles[role]}</h4>
               {
                this.roles.users[role].map((perm, key) => {
                 return (
                  <div key={key} className="form-check form-check-inline">
                   <Input className="form-check-input" type="checkbox" disabled={!this.state.rolesEditable} onChange={(event) => this.checkBoxValue('users', role, perm, event)} checked={this.checkBoxStatus('users', role, perm)} />
                   <Label className="form-check-label">{Lang[this.props.session.language].Settings.permissions[perm]}</Label>
                  </div>
                 )
                })
               }
              </div>
             )
            })
           }
          </Col>
          <Col xs="6">
           {
            Object.keys(this.roles.controllers).map((controller, key) => {
             return (
              <div key={key} className="mb-3">
               <h4>{Lang[this.props.session.language][capitalize(controller)].title}</h4>
               {
                this.roles.controllers[controller].map((perm, key) => {
                 return (
                  <div key={key} className="form-check form-check-inline">
                   <Input className="form-check-input" type="checkbox" disabled={!this.state.rolesEditable} onChange={(event) => this.checkBoxValue('controllers', controller, perm, event)} checked={this.checkBoxStatus('controllers', controller, perm)} />
                   <Label className="form-check-label">{Lang[this.props.session.language].Settings.permissions[perm]}</Label>
                  </div>
                 )
                })
               }
              </div>
             )
            })
           }
          </Col>
         </Row>
        </Col>
       </Row>
      </CardBody>
     </Card>
    </Col>
   </Row>
  )
 }
}

export default SettingsEditor;


// WEBPACK FOOTER //
// ./websources/views/Settings/Editor.js